import { useState } from 'react'
import { Button, Form, Input, Modal } from 'antd'
import md5 from 'md5'
const App = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [result, setResult] = useState('')
  const handleOk = () => {
    setIsModalOpen(false)
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }
  const onFinish = values => {
    const str = values.str
    const result = md5(str)
    setResult(result)
    setIsModalOpen(true)
  }
  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo)
  }
  return (
    <>
      <Form
        name="basic"
        labelCol={{
          span: 4
        }}
        wrapperCol={{
          span: 16
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="字符串"
          name="str"
          validateTrigger="onBlur"
          rules={[
            {
              required: true,
              message: '请输入要转换为MD5的字符串'
            }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          wrapperCol={{
            offset: 9,
            span: 4
          }}
        >
          <Button type="primary" htmlType="submit">
            转换
          </Button>
        </Form.Item>
      </Form>
      <Modal
        title="转换结果"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="确定"
        cancelText="取消"
      >
        <p>{result}</p>
      </Modal>
    </>
  )
}
export default App
